module.exports = __webpack_public_path__ + "img/spirit_Image_two.718fcffb.png";